import { motion } from "framer-motion";
import { Reveal } from "@/components/motion/Reveal";
import { INDUSTRIES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const DESCRIPTIONS = {
  "E-commerce": "Convert browsers into loyal buyers with instant, personalized support at scale.",
  "Financial Services": "Secure, compliant conversations that build trust with every interaction.",
  Healthcare: "Compassionate, always-on patient engagement with strict privacy controls.",
  Education: "Guide students and staff with responsive, multilingual assistance.",
  Technology: "Scale developer and product support without scaling headcount.",
  Retail: "Unify in-store and online service into one seamless customer journey.",
};

export default function Industries() {
  const row = [...INDUSTRIES, ...INDUSTRIES];
  return (
    <section
      id="industries"
      className="relative py-24 lg:py-36 bg-white overflow-hidden"
      data-testid="industries-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mb-14">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#9CA3AF]">
            Industries
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 max-w-2xl font-display text-4xl lg:text-5xl font-extrabold tracking-tighter leading-[1.02] text-[#1F2937]">
            Tailored intelligence for every sector
          </h2>
        </Reveal>
      </div>

      {/* Editorial marquee */}
      <div className="relative flex w-max animate-marquee mb-16">
        {row.map((word, i) => (
          <div key={i} className="flex items-center gap-10 px-10">
            <span className="font-display text-6xl sm:text-7xl lg:text-8xl font-extrabold tracking-tighter text-stroke whitespace-nowrap">
              {word}
            </span>
            <span className="font-display text-6xl sm:text-7xl lg:text-8xl font-extrabold text-[#EEF1F4]">
              /
            </span>
          </div>
        ))}
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, ease: EASE, delay: (i % 3) * 0.07 }}
              whileHover={{ y: -5 }}
              className="group rounded-3xl bg-[#F5F6F8] p-8 lg:p-10 border border-transparent hover:bg-white hover:border-[#EEF1F4] hover:shadow-xl hover:shadow-gray-200/60 transition-[background-color,box-shadow,border-color] duration-500"
              data-testid={`industry-${ind.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="font-display text-sm font-bold text-[#9CA3AF]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#1F2937]">
                {ind}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6B7280]">
                {DESCRIPTIONS[ind]}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
